import { Component, Input, ElementRef, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

interface Option {
  value: string;
  label?: string;
  icon?: string;
}
@Component({
  selector: 'bepatient-onboarding-input-radio',
  templateUrl: './onboarding-input-radio.component.html',
  styleUrls: ['./onboarding-input-radio.component.scss'],
  standalone: false
})
export class OnboardingInputRadioComponent {
  private element = inject(ElementRef);

  _color: string;

  @Input() type;
  @Input() options: Array<Option>;
  @Input() bpFormGroup: UntypedFormGroup;
  @Input() bpFormControlName: UntypedFormControl;
  @Input() set color(color: string) {
    this._color = color;
    this.element.nativeElement.style.setProperty('--font-color', color);
  }
  get color() {
    return this._color;
  }

  setFormControlValue(option: Option): void {
    this.bpFormControlName.value === option.value
      ? this.bpFormControlName.reset()
      : this.bpFormControlName.setValue(option.value);
  }
}
